import { gql } from "@apollo/client";
import AboutPageConfigFields from "~/src/components/home/pages/graphql/fragments/AboutPageConfigFields";

export default gql`
  query GetActiveAboutPageConfig($configId: ObjectId) {
    getActiveAboutPageConfig(configId: $configId) {
      ...AboutPageConfigFields
    }
  }

  ${AboutPageConfigFields}
`;
